import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-copyright-detail',
  templateUrl: './copyright-detail.component.html',
  styleUrls: ['./copyright-detail.component.scss']
})
export class CopyrightDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
